import(/* webpackMode: "eager" */ "/vercel/path0/app/(comLayout)/institucional/diretoria/page.tsx");
